import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Sprout } from "lucide-react";

export default function ProtectedRoute({ roles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#F9F8F6]">
        <div className="flex flex-col items-center gap-3">
          <Sprout className="w-10 h-10 text-[#1E3F20] animate-pulse" />
          <p className="text-[#5C6B5E] text-sm">Loading…</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
